// Charge la base commune
import './common.js'

// Agencies Search Form
async function getAsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getEEForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/estimateExtensionForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then((module) => {
    module.agenciesAutocomplete.init($f)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a')
      .off()
      .on('click', function () {
        const h = $('#header').height()
        const p = $(this).parents('.pajinate-nav').height()
        $('html').animate(
          { scrollTop: $('#step-pagination').offset().top - h - p - 10 },
          { duration: 300, easing: 'linear' }
        )
      })
  })
}

// Models Search Form
async function getHmsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "houseModelsSearchForm" */ './js/components/houseModelsSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion de la recherche d'agences la plus proche
  const $c1 = $('form[name="asForm"]')
  if ($c1.length) {
    $c1.waypoint(
      function () {
        getAsForm($c1)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // gestion du formulaire de contact
  const $c2 = $('form[name="cForm"]')
  if ($c2.length) {
    $c2.waypoint(
      function () {
        getCForm($c2)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // gestion du formulaire de contact
  const $c3 = $('form[name="eeForm"]')
  if ($c3.length) {
    $c3.waypoint(
      function () {
        getEEForm($c3)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })

  // gestion des pages
  const $c4 = $('.pajinate')
  if ($c4.length) {
    $c4.waypoint(
      function () {
        getPajination()
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // formulaire de recherche des modèles
  const $c5 = $('form[name="qhmsForm"]')
  if ($c5.length) {
    $c5.waypoint(
      function () {
        getHmsForm($c5)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // gestion advice items
  const $extendTypeBlock = $('.extendTypeBlock')
  if ($extendTypeBlock.length) {
    $extendTypeBlock.waypoint(
      function () {
        import(/* webpackChunkName: "extendTypeBlock" */ './scss/components/extendTypeBlock.scss').then(() => {
          Waypoint.refreshAll()
        })
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }
})
